import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { protectedResources } from 'src/app/auth/auth.config';
import {
  AircraftConfiguration,
  PartWithMaintenanceDetails,
  WebMaintenanceUploadStatus,
} from '../models/maintenancelogs.model';
@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  apiEndpoint: string = protectedResources.apiTodoList.endpoint;

  constructor(private readonly http: HttpClient) {}

  getMaintenanceLogUploadStatus() {
    const headers = new HttpHeaders({
      Accept: 'application/vnd.web.maintenance.upload-status.v1+json',
    });
    return this.http
      .get<
        WebMaintenanceUploadStatus[]
      >(`${this.apiEndpoint}/maintenance/log/upload`, { headers })
      .pipe(map((response) => response || []));
  }

  uploadMaintenanceLog(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(
      `${this.apiEndpoint}/maintenance/log/upload`,
      formData,
      {
        headers: {
          Accept: 'application/vnd.web.maintenance.upload-status.v1+json',
        },
      },
    );
  }

  retryMaintenanceLog(id: string): Observable<any> {
    return this.http.post(
      `${this.apiEndpoint}/maintenance/log/upload/${id}/retry`,
      {},
    );
  }

  getMaintenanceLogsFromConfigurationsOfLatestFlightOfAircraft(
    modelKey: string,
    unitNumber: string,
    configurationName: string,
  ) {
    const headers = new HttpHeaders({
      Accept: 'application/vnd.web.maintenance.part.details.v1+json',
    });

    const params = new HttpParams().set('configurationName', configurationName);

    return this.http.get<PartWithMaintenanceDetails[]>(
      `${this.apiEndpoint}/maintenance/aircraft/${modelKey}/${unitNumber}/logs`,
      { headers, params },
    );
  }

  getConfigurationsFromLastFlightOfAircraft(
    modelKey: string,
    unitNumber: string,
  ) {
    const headers = new HttpHeaders({
      Accept: 'application/vnd.web.maintenance.configuration.details.v1+json',
    });
    return this.http.get<AircraftConfiguration[]>(
      `${this.apiEndpoint}/maintenance/aircraft/${modelKey}/${unitNumber}/latestConfigurations`,
      { headers },
    );
  }
}
